import script from "./Access.vue?vue&type=script&setup=true&lang=js"
export * from "./Access.vue?vue&type=script&setup=true&lang=js"

import "./Access.vue?vue&type=style&index=0&id=59f2037e&lang=css"

const __exports__ = script;

export default __exports__